import { find, findIndex } from 'lodash';

export function getCallback(callbacks = [], callbackName = '') {
  const formattedCallbackName = callbackName?.toLowerCase();
  const result = find(callbacks, (callbackObj) => callbackObj?.type?.toLowerCase() === formattedCallbackName);

  return result;
}

export function getCallbackIndex(callbacks, callbackName) {
  const formattedCallbackName = callbackName?.toLowerCase();

  const result = findIndex(callbacks, (callbackObj) => callbackObj?.type?.toLowerCase() === formattedCallbackName);

  return result;
}

// NOTE: for now, there is no specific handler for hidden value callbacks in the useFRCallback hook - as in our journeys, there is potential for multiple hidden value callbacks.
// use this function to get the hidden value callback by id of the hidden value desired.

export function getHiddenValueCallbackById(callbacks, desiredCallbackId) {
  let result;
  // iterate through callbacks to find a hidden value callback
  for (const callbackObj of callbacks) {
    const { type = '', output = [] } = callbackObj;

    let isDesiredCallback = false;
    if (type?.toLowerCase() === 'hiddenvaluecallback') {
      // extract output object with the 'id' of the hidden value
      const hiddenValueObj = find(output, (outputObj) => outputObj?.name?.toLowerCase() === 'id');

      // determine if the output 'id' matches the id of the callback desired
      if (hiddenValueObj?.value?.toLowerCase() === desiredCallbackId) {
        isDesiredCallback = true;
      }

      // set the callbackObj to the output if this is the desired callback
      if (isDesiredCallback) {
        result = callbackObj;
      }
    }
  }

  return result;
}

export function getHiddenValueCallbackIndexById(callbacks, desiredCallbackId) {
  let result;
  // iterate through callbacks to find a hidden value callback
  for (const [index, callbackObj] of callbacks.entries()) {
    const { type = '', output = [] } = callbackObj;

    let isDesiredCallback = false;
    if (type?.toLowerCase() === 'hiddenvaluecallback') {
      // extract output object with the 'id' of the hidden value
      const hiddenValueObj = find(output, (outputObj) => outputObj?.name?.toLowerCase() === 'id');

      // determine if the output 'id' matches the id of the callback desired
      if (hiddenValueObj?.value?.toLowerCase() === desiredCallbackId) {
        isDesiredCallback = true;
      }

      // set the index of the callbackObj to the output if this is the desired callback
      if (isDesiredCallback) {
        result = index;
      }
    }
  }

  return result;
}
